import { Close, CloseFullscreen, OpenInFull } from '@mui/icons-material';
import { IconButton, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useCameraDetailsOverlayStyles from '../styles';
import { WidgetOverlayProps } from './types';

const WidgetOverlay: React.FunctionComponent<WidgetOverlayProps> = (props) => {
  const classes = useCameraDetailsOverlayStyles();
  const { t } = useTranslation(['video', 'common']);
  const currentTimeout = useRef<NodeJS.Timeout>();

  const {
    data,
    removeFromLayout,
    goFullScreen,
    exitFullScreen,
    hideWhenDragged = false,
    addonsRight,
  } = props;

  const [isFullScreen, setIsFullScreen] = useState(false);

  const closeFullscreen = () => {
    !document.fullscreenElement && setIsFullScreen(false);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', closeFullscreen);
    return () => {
      document.removeEventListener('fullscreenchange', closeFullscreen);
      // eslint-disable-next-line react-hooks/exhaustive-deps
      currentTimeout.current && clearTimeout(currentTimeout.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderWidgetOverlay = () => {
    return (
      <>
        {!hideWhenDragged && (
          <div className={classes.videoControllsWrapper} draggable={false}>
            <Typography variant='body1' className={classes.videoControllsTitle}>
              {data.name}
            </Typography>
            <div className={classes.videoControllsButtonsWrapper}>
              {!isFullScreen && goFullScreen && (
                <Tooltip title={t('common:fullscreen')}>
                  <IconButton
                    size='small'
                    onClick={() => {
                      goFullScreen();
                      setIsFullScreen(true);
                    }}
                  >
                    <OpenInFull className={classes.videoControllsButton} fontSize='small' />
                  </IconButton>
                </Tooltip>
              )}
              {isFullScreen && exitFullScreen && (
                <Tooltip title={t('common:exitFullscreen')}>
                  <IconButton
                    size='small'
                    onClick={() => {
                      exitFullScreen();
                    }}
                  >
                    <CloseFullscreen className={classes.videoControllsButton} fontSize='small' />
                  </IconButton>
                </Tooltip>
              )}
              {removeFromLayout && (
                <Tooltip title={t('common:remove')}>
                  <IconButton size='small' onClick={() => removeFromLayout(data.id)}>
                    <Close className={classes.videoControllsButton} fontSize='small' />
                  </IconButton>
                </Tooltip>
              )}
              {addonsRight}
            </div>
          </div>
        )}
      </>
    );
  };

  return renderWidgetOverlay();
};

export default WidgetOverlay;
